import { render, staticRenderFns } from "./invDetail.vue?vue&type=template&id=7ded865d"
import script from "./invDetail.vue?vue&type=script&lang=js"
export * from "./invDetail.vue?vue&type=script&lang=js"
import style0 from "./invDetail.vue?vue&type=style&index=0&id=7ded865d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports